var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',[_vm._v("Loading editor...")]):(_vm.error)?_c('div',{staticClass:"error"},[_vm._v("Failed to load editor: "+_vm._s(_vm.error))]):_c('editor',{attrs:{"init":_vm.initOptions},on:{"input":_vm.updateContent},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }